import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funktionsbereiche-rollen';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungFunktionsbereicheRollenEffects {

    FunktionsbereicheRollen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKTIONSBEREICHE_ROLLEN),
        mergeMap((x: ac.GetFunktionsbereicheRollenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunktionsbereicheRollen().pipe(
                map((result: any) => {
                    return new ac.GetFunktionsbereicheRollenErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunktionsbereicheRollenFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenQueryService);
        }
        return this.service;
    }
}
